<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <bill-list
          :bills="notPaidBills"
          :loading="loadingData"
          title="Próximas mensalidades"
          description="Veja as próximas mensalidades e adiante pagamentos."
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadcrumb from 'components/breadcrumb';
import BillList from 'components/bill-list';

export default {
  components: {
    BillList,
    Breadcrumb,
  },
  data() {
    return {
      hasBills: true,
      loadingData: true,
    };
  },
  computed: {
    ...mapState([
      'notPaidBills',
    ]),
  },
  methods: {
    ...mapActions([
      'loadNotPaidBills',
    ]),
  },
  mounted() {
    this.loadNotPaidBills()
      .then(() => {
        if (this.notPaidBills.length === 0) {
          this.hasBills = false;
        }
        this.loadingData = false;
      })
      .catch((error) => this.$rollbar.error(error));

    this.$tracker.logEvent('[next bills] Viewed Bills Page');
  },
};
</script>
